export const C99_INSTANCE_PATTERN = /^inst:channel99.*$/;
